module.exports = __webpack_public_path__ + "09a435334466c1f2042770dd90b9f6ef.svg";